import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddressDetailComponent } from './address-detail/address-detail.component';
import { FollowListComponent } from './follow-list/follow-list.component';

const routes: Routes = [
    {
        path: ':address',
        component: AddressDetailComponent,
    },

    {
        path: ':address/followers',
        component: FollowListComponent,
        data: { type: 'follower' },
    },
    {
        path: ':address/followings',
        component: FollowListComponent,
        data: { type: 'following' },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AddressRoutingModule {}
